exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-retirement-js": () => import("./../../../src/pages/retirement.js" /* webpackChunkName: "component---src-pages-retirement-js" */),
  "component---src-pages-whatcaniafford-js": () => import("./../../../src/pages/whatcaniafford.js" /* webpackChunkName: "component---src-pages-whatcaniafford-js" */)
}

